import { Link } from '@mui/material';
import FlexContainer from 'components/FlexContainer';
import { ProgressToastFunctions } from 'components/toasts/createProgressToast';
import {
  deleteBrandVoiceAfterDuplication,
  navigateInIframe
} from 'features/brand-hub-v2/newAppPostMessage';
import FormattedMessage from 'features/i18n/FormattedMessage';
import { MouseEvent } from 'react';
import { GAEvents } from 'services/tracking/GAEvents';
import styled from 'styled-components';
import { truncateText } from 'utils/truncateText';

type Props = {
  brandVoiceName: string;
  brandVoiceId: string;
  toast: ProgressToastFunctions;
};

export const BrandVoiceDuplicationSuccessToastContent = ({
  brandVoiceName,
  brandVoiceId,
  toast
}: Props) => {
  const name = truncateText(brandVoiceName, 20);

  const handleEditClick = (event: MouseEvent) => {
    event.preventDefault();

    toast.close();
    GAEvents.brandVoiceEditStart({ brandVoiceId });
    navigateInIframe(`/my-brand-hub/brand-voice/${brandVoiceId}?edit=true`);
  };

  const handleUndoClick = (event: MouseEvent) => {
    event.preventDefault();

    toast.close();
    deleteBrandVoiceAfterDuplication(brandVoiceId, brandVoiceName);
  };

  return (
    <FlexContainer direction="row" justifyContent="space-between" gap="four">
      <FormattedMessage id="brand_hub.brand_voice.duplication_toast.success" values={{ name }} />

      <FlexContainer direction="row" alignItems="center" gap="two">
        <LinkButton onClick={handleEditClick}>
          <FormattedMessage id="brand_hub.brand_voice.duplication_toast.edit_button" />
        </LinkButton>
        <LinkButton onClick={handleUndoClick}>
          <FormattedMessage id="brand_hub.brand_voice.duplication_toast.undo_button" />
        </LinkButton>
      </FlexContainer>
    </FlexContainer>
  );
};

const LinkButton = styled(Link)`
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`;
